import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';

import QRScanner from './QrScanner'; // Ensure QRScanner is correctly implemented
import './QrScanner.less';
import { useNotification } from '../notification/Notification';

const QrCameraPage: React.FC = () => {
    const history = useHistory();
    const [scannedData, setScannedData] = useState<string[]>([]);
    const { showNotification } = useNotification();

    const handleScan = (data: any) => {
        if (data && !scannedData.includes(data)) {
            setScannedData((prev) => {
                const newData = Array.from(new Set([...prev, data]));
                if (newData.length > prev.length) {
                    showNotification('success', 'Numérisé avec succès.', `Bon d'emballage scanné`);
                }
                return newData;
            });
        }
    };

    const handleRedirect = () => {
        history.push('/qrReading', { scannedData });
    };

    return (
        <div className="qr-scanner-page">
            <div className="qr-scanner-container">
                <QRScanner onScan={handleScan} />
                <Button type="primary" className="mt-4" htmlType="submit" onClick={handleRedirect}>
                    Suivant
                </Button>
            </div>
        </div>
    );
};

export default QrCameraPage;
